export default __webpack_public_path__ + "static/media/img4.e8972fd8.jpg";